import axios from "axios";
import { toast } from "sonner";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const getToken = () => localStorage.getItem("namo_token");
export const setToken = (t) => (t ? localStorage.setItem("namo_token", t) : localStorage.removeItem("namo_token"));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

let whatsapp = "";
export const setWhatsapp = (w) => (whatsapp = w);
export const waLink = (text = "Hi NamoAI, I want to recharge credits") =>
  `https://wa.me/${whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function handleErr(e) {
  const msg = errMsg(e);
  if (e?.response?.status === 402) window.dispatchEvent(new CustomEvent("namo:paywall", { detail: msg }));
  else toast.error(msg);
  return msg;
}

export const fileUrl = (kind, id) => `${API}/files/${kind}/${id}?auth=${getToken()}`;

export async function streamChat(chatId, text, attachments, onChunk) {
  const res = await fetch(`${API}/chats/${chatId}/message`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify({ text, attachments }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.detail || "Request failed");
    err.response = { status: res.status, data: body };
    throw err;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  let final = {};
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.t) onChunk(ev.t);
      if (ev.error) throw new Error(ev.error);
      if (ev.done) final = ev;
    }
  }
  return final;
}
